import { gql } from "graphql-tag";

/**
 * Fetches prices using id and UpdatedAt
 *
 * variable example
 * { "ids": "(id,in,48,49)" }
 */
export const GET_SyncedPrices = gql`
  query GetSyncedPrices($condition: String!) {
    prices: ProductSlotPriceList(where: $condition) {
      id: Id
      quantity: QuantitAvailable
      totalQuantity: Quantity
      updatedAt: UpdatedAt
      __typename
      category: ProductSlotCategoryRead {
        product: ProductRead {
          group: GroupRead {
            groupUuid: Uuid
            __typename
          }
          __typename
        }
        __typename
      }
    }
  }
`;
